import Ease from '@CS/utils/Easing';
import { Screen } from '@CS/app/App.styles';
import styled, { css } from 'styled-components';

const TRANSITION_DURATION = 500;
export const FADE_DURATION = TRANSITION_DURATION - 100;

type PopupOverlayAttributes = {
  opacity: number | string;
  $visible: boolean;
  $overlay: boolean;
};

export const PopupOverlay = styled.aside<PopupOverlayAttributes>(
  ({ $visible, $overlay, opacity }) => css`
    transition: background-color ${FADE_DURATION}ms;
    background-color: rgb(0 0 0 / 0);
    position: fixed;

    height: 100%;
    width: 100%;

    z-index: 2;
    padding: 0;
    margin: 0;

    bottom: 0;
    right: 0;
    left: 0;
    top: 0;

    ${$visible &&
    css`
      ${$overlay &&
      css`
        background-color: rgb(0 0 0 / ${opacity});
      `}

      > dialog {
        transition-timing-function: ${Ease.Out.Sine};
        transform: translate(-50%, -50%) scale(1);
        transition-delay: 0s;
        opacity: 1;
      }
    `}
  `
);

const BACKGROUND_COLOR = 'white';
const OPACITY_DURATION = TRANSITION_DURATION * 0.5;
export const CLOSE_SIZE = 'clamp(20px, 6.667vmin, 30px)';

type PopupContainerAttributes = {
  width?: number | string;
  $fullScreen?: boolean;
  $background?: string;
};

export const PopupContainer = styled.dialog<PopupContainerAttributes>(
  ({ $fullScreen, $background, width }) => css`
    transition:
      transform ${FADE_DURATION}ms ${Ease.In.Sine},
      opacity ${OPACITY_DURATION}ms ${FADE_DURATION - OPACITY_DURATION}ms;

    background-color: ${$background ?? BACKGROUND_COLOR};
    transform: translate(-50%, -50%) scale(0.75);
    box-shadow: 0 3px 6px 0 rgb(0 0 0 / 0.16);

    will-change: transform, opacity;
    border: 1px solid rgb(34 34 34);
    backface-visibility: hidden;
    padding: min(3.5vmax, 25px);

    max-width: ${Screen.MAX};
    transform-origin: 50%;
    border-radius: 15px;
    position: absolute;

    max-height: 90vmax;
    min-height: 50vmax;
    min-width: 256px;

    overflow: auto;
    display: block;
    height: auto;

    opacity: 0;
    margin: 0;

    left: 50%;
    top: 50%;

    ${width &&
    css`
      width: ${width}%;
    `}

    ${$fullScreen &&
    css`
      max-height: 100dvh;
      border-radius: 0;

      height: 100dvh;
      width: 100vw;
      border: none;
    `}

    > svg {
      height: ${CLOSE_SIZE};
      width: ${CLOSE_SIZE};

      position: relative;
      margin-left: auto;
      margin-right: 0;

      cursor: pointer;
      display: block;
      z-index: 1;
    }
  `
);
